<template>
  <div class="store">
    
    <b-input placeholder="search.."  rounded v-model="search" icon="magnify" expanded></b-input>
    <div class="container" :class="{loadingItem: isProductLoading}">
  <div class="row text-center" v-if="isProductLoading">
    <grid-loader :loading="isProductLoading" :color="loaderColor" :size="loaderSize"></grid-loader>
  </div>
  <div v-else class="row action-panel">
    <div class="col-12">

    </div>
  </div>

  <div class="row">
    <app-product-item v-for="prod in filteredProducts" :item="prod" :key="prod.id" :displayList="displayList"></app-product-item>
  </div>
  
</div>
<br>
  </div>
</template>
<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import ProductItem from './product/ProductItem.vue';
export default {
  props: ['item'],
  data() {
    return {
      loaderColor: "#5cb85c",
      loaderSize: "50px",
      displayList: false,
      password: "",
      products: [],
      search: ""
    };
  },
  computed: {
    ...mapGetters(["isProductLoading"]),
    filteredProducts: function() {
      return this.products.filter(product => {
        return product.name.match(new RegExp(`${this.search}`, "gi"));
      });
    },
    
  },
  components: {
    appProductItem: ProductItem,
  },
  methods: {
    ...mapActions(["updateCart"]),
    addItem() {
      alert('added')
      this.isActive = true;
      const order = {
        item: Object.assign({}, this.item),
        quantity: 1,
        isAdd: true
      };
      this.updateCart(order);
    },
    success() {
      this.$buefy.toast.open({
        message: "Something happened correctly!",
        type: "is-success"
      });
    },
    changeDisplay(isList) {
      this.displayList = isList;
    },
    submit() {
      this.$fb.database
        .collection("tests")
        .add({
          password: this.password
        })
        .then(console.log(this.password));
    }
  },
  filters: {
    shortDescription(value) {
      if (value && value.length > 100) {
        return value.substring(0, 100) + "...";
      } else {
        return value;
      }
    },
    shorterDescription(value) {
      if (value && value.length > 30) {
        return value.substring(0, 25) + "...";
      } else {
        return value;
      }
    }
  },
  created() {
    this.$fb.database
      .collection("Product")
      .get()
      .then(querySnapshot => {
        querySnapshot.forEach(doc => {
          this.loading = true;
          let data = {
            name: doc.data().name,
            description: doc.data().description,
            price: doc.data().price,
            slug: doc.data().slug,
            quantity: doc.data().quantity,
            picture: doc.data().picture
          };

          this.products.push(data);
          this.loading = false;
        });
      });
  }
};
Vue.filter("uppercase", function(value) {
  return value.toUpperCase();
});
</script>
<style >
.products {
  justify-content: space-evenly;
}
.product {
  width: 300px;
  height: 500px;
  margin-top: 1.5em;
  margin-bottom: 1.5em;
  overflow: hidden;
}
.store {
    margin-top: 2em;
    width: 100%;
  }
.img {
  margin: 2em;
}
.img:hover {
  transform: scale(1.1);
}
.productname {
  color: green;
  margin-left: 1em;
}
.description {
  color: black;
  margin-top: 0.5em;
  margin-left: 1em;
}
.actions {
  display: flex;
}
.row{
  justify-content: space-evenly;
}
.add {
  margin-top: 0.5em;
  margin-left: 3em;
}
.desc {
  color: green;
  margin-left: 1em;
}
@media only screen and (max-width: 630px) {
  .product {
    width: 150px;
    height: 300px;
  }
  .desc {
    display: none;
  }
  .actions {
    display: block;
  }
  .add {
    margin: 0;
    width: 100%;
  }
  .productname {
    font-size: 0.9em;
    text-transform: lowercase;
    text-align: left;
  }
  .store {
    margin-top: 2em;
    width: 100%;
  }
}
</style>
